import { AutoThrow } from "@pdfking/errors"
import { OpfsFileSystem, UfsFileSystem } from "@pdfking/storages/browser"
import type { FileName } from "@pdfking/structs"
import type { StringGUID } from "@pdfking/tfunc"

import type { UrlProtocolHandler } from "#internal"

import {
  ImplementUrlLoad,
  UrlHit,
  UrlStoreKey,
  UrlStoreName,
} from "../../internal/ImplementUrlLoad"

// The origin's own private folder, named by the url: nothing can refuse it, so
// the read is the read.
const OpfsFetch: UrlProtocolHandler = async url =>
  UrlHit(
    url,
    await OpfsFileSystem(UrlStoreName(url) as StringGUID).get(UrlStoreKey(url) as FileName)
  )

// The folder the user picked, named by the grant it was filed under and the
// database that holds it — `ufs://{grant}@{database}/{path}`. The one read
// here that can be refused: a grant that did not survive the reload comes back
// only through a click, so a url alone cannot always open one, and the reason
// it could not is what the failure says.
const UfsFetch: UrlProtocolHandler = async url => {
  const fs = AutoThrow(await UfsFileSystem(UrlStoreName(url), decodeURIComponent(url.username)))
  return UrlHit(url, await fs.get(UrlStoreKey(url) as FileName))
}

/**
 * Load URL using fetch (browser environment)
 * @param path - URL or path to the file
 * @param mime - MIME type (only used by non-fetch protocols like fs:)
 * @returns Response for streaming instantiation
 */
export const UrlLoad = ImplementUrlLoad({
  "opfs:": OpfsFetch,
  "ufs:": UfsFetch,
})
